<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <strong>In-Transit Report</strong>
              <div
                class="card-header-actions"
              >
              </div>
            </div>

            <b-row>
                <b-col sm="12" class="text-right  " >
                    <a :href="loadurl" target="_blank" class="ml-3">
                        <b-button variant="primary"  size="md" @click="downlaodloadurl">Download</b-button>
                    </a>
                </b-col>
                <br><br><br>
                <b-col sm="12" class="text-right  " >
                    <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> 
                </b-col>
                <b-col md="12">
                    <b-table
                    id="my-table"
                    show-empty
                    responsive
                    :items="items"
                    :busy="isBusy"
                    :current-page="currentPage"
                    :fields="fields"
                    :per-page="perPage"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :bordered="bordered" 
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    </b-table>
    
                
                </b-col>
            </b-row>
            <b-col md="12" class="my-1" >
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
            ></b-pagination>
            </b-col>   
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  export default {
    data() {
      return {
        totalRows : 0,
        items: [],
        fields: [
          { key: "destinationcity", label: "Destination City", sortable: true },
          { key: "mpscount", label: "NO OF Boxes", sortable: true },
          { key: "valweight", label: "Volumetric Weight", sortable: true },
          { key: "estimated_delivery_datetime", label: "Estimated Arrival Date", sortable: true },
          { key: "vendorname", label: "Vendor Name", sortable: true },
        ],
        loadurl :'',
        currentPage : 1,
        perPage : 20,

      };
    },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.User_type = userInfo.user_type;
      console.log("userInfo", userInfo);
      this.intransitListing(this.pageNum);
    },
    methods: {
        intransitListing(pageNo){
            this.isBusy = true;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);

            // let pincode=JSON.stringify(userInfo.pickuplocationpincode);
            let obj = {
            for_status: "INTransit",
            is_asn: 'YES'
            }
            console.log("obj",obj)

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getINTransitReport_ForASN`,obj)
                .then(result => {
                // console.log(result.body);
                    this.isBusy = false;
                    if(result.body.returnmsg === "Successful"){
                    
                    this.items  = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue.length;
                    // this.noofpages=parseInt(this.totalRows)/60;
                    // this.noofpages=Math.ceil( this.noofpages);
                    }else{
                    this.items  = [];
                    this.totalRows = 0;
                    }
                }).catch(ex => {
                console.log('error', ex)
                })
        },
        
        downlaodloadurl(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`INTransit`+`&&`+`is_asn=`+'YES'

        this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForInTransitResportForASN?is_asn=`+'YES' +`&&`+`for_status=`+'INTransit'
        console.log("this.loadurl",this.loadurl)
      },
    },
    computed: {
      rows() {
        return this.items.length
      }
    }
  };
  </script>
  

  